import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  __name: 'TopicSelecter',
  props: ["value", "placeholder", "limit"],
  emits: ["input"],
  setup(__props) {




return (_ctx: any,_cache: any) => {
  const _component_a_option = _resolveComponent("a-option")!
  const _component_a_optgroup = _resolveComponent("a-optgroup")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    placeholder: __props.placeholder,
    "allow-search": { retainInputValue: true },
    value: __props.value,
    onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('input', $event.target.value))),
    multiple: "",
    limit: __props.limit,
    style: {"min-width":"200px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_optgroup, { label: "话题" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("学习打卡")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("面试题")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("面经")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("提问")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("简历")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("自我介绍")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_optgroup, { label: "程序员" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("前端")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("后端")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("数据库")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("项目分享")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("项目")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["placeholder", "value", "limit"]))
}
}

})